import { canAccessRoute } from '@platform/authz';
import { allRoutes } from '@platform/contracts';
/**
 * A screen is gated by the contract route it leads to — the same `canAccessRoute` the API
 * gateway applies, over the same manifest, so the menu never shows a page the API would
 * refuse. Unknown operation ids fail at module evaluation, i.e. in the first test run.
 */
export function routeFor(context, operationId) {
    const route = allRoutes.find((r) => r.context === context && r.operationId === operationId);
    if (!route)
        throw new Error(`No route ${context}.${operationId} in the contracts manifest`);
    return route;
}
/** A gate for a surface whose contract has not landed: auth kind + action, checked the same way. */
export function routeLike(auth, action) {
    return { auth, action };
}
export function canOpen(principal, route) {
    if (!principal)
        return route.auth === 'public';
    return canAccessRoute(principal, route).allowed;
}
//# sourceMappingURL=routes.js.map